import React from 'react';
import { debounce } from 'lodash';

export type UseDoubleClickHandlerParams = {
    onClick?: (args: any) => void;
    onDoubleClick?: (args: any) => void;
    onTriplePlusClick?: (args: any, clickCount: number) => void;
    clickThreshhold?: number;
}

export const useDoubleClickHandler = ({ onClick, onDoubleClick, onTriplePlusClick, clickThreshhold = 500 }: UseDoubleClickHandlerParams) => {
    const bounce = React.useRef<(() => void) | undefined>(undefined);
    const clickCount = React.useRef<number>(0);

    const internalClickHandler = (fArgs: any) => {
        clickCount.current = clickCount.current + 1;

        if (!bounce.current) {
            bounce.current = debounce(() => {
                try {
                    if (clickCount.current === 1 && onClick)
                        onClick(fArgs);
                    if (clickCount.current === 2 && onDoubleClick)
                        onDoubleClick(fArgs);
                    if (clickCount.current >= 3 && onTriplePlusClick)
                        onTriplePlusClick(fArgs, clickCount.current);
                }
                finally {
                    clickCount.current = 0;
                    bounce.current = undefined;
                }
            }, clickThreshhold, {
                leading: false,
                trailing: true
            });
            bounce.current();
        }
    }

    return internalClickHandler;
}
